import { useState } from "react";
import { Download, Share, PlusSquare, X, CheckCircle2 } from "lucide-react";
import { Btn } from "./Btn";
import { useInstall } from "@/lib/install";

function IOSSteps() {
  return (
    <ol className="mt-3 flex flex-col gap-2 text-sm text-t-on2" data-testid="install-ios-steps">
      <li className="flex items-center gap-2"><span className="w-6 h-6 rounded-full bg-t-brand3 text-t-brand grid place-items-center text-xs font-bold">1</span>Tap <Share size={16} className="text-t-brand" /> <b>Share</b> in Safari's toolbar</li>
      <li className="flex items-center gap-2"><span className="w-6 h-6 rounded-full bg-t-brand3 text-t-brand grid place-items-center text-xs font-bold">2</span>Choose <PlusSquare size={16} className="text-t-brand" /> <b>Add to Home Screen</b></li>
      <li className="flex items-center gap-2"><span className="w-6 h-6 rounded-full bg-t-brand3 text-t-brand grid place-items-center text-xs font-bold">3</span>Tap <b>Add</b> — Triggerific-Pilot opens full-screen from your home screen</li>
    </ol>
  );
}

// Full card for Settings.
export function InstallCard() {
  const { canPrompt, installed, ios, install } = useInstall();
  if (installed)
    return <p className="flex items-center gap-2 text-t-on2" data-testid="install-installed"><CheckCircle2 size={18} className="text-t-brand" /> Triggerific-Pilot is installed on this device.</p>;
  return (
    <div data-testid="install-card">
      {canPrompt ? (
        <Btn size="md" icon={<Download size={16} />} label="Install Triggerific-Pilot" onClick={install} testId="install-button" />
      ) : ios ? (
        <IOSSteps />
      ) : (
        <p className="text-sm text-t-on2" data-testid="install-manual">
          Open your browser menu (⋮) and choose <b>Install app</b> or <b>Add to Home screen</b>. On iPhone, use Safari's Share button → <b>Add to Home Screen</b>.
        </p>
      )}
    </div>
  );
}

// Small dismissible banner for phones that haven't installed yet.
export function InstallBanner() {
  const { canPrompt, installed, ios, install } = useInstall();
  const [hidden, setHidden] = useState(localStorage.getItem("tf.installDismissed") === "1");
  const [showSteps, setShowSteps] = useState(false);
  const mobile = window.matchMedia("(max-width: 767px)").matches;
  if (installed || hidden || !mobile || (!canPrompt && !ios)) return null;
  const dismiss = () => {
    localStorage.setItem("tf.installDismissed", "1");
    setHidden(true);
  };
  return (
    <div className="tf-card p-4 tf-rise" data-testid="install-banner">
      <div className="flex items-center gap-3">
        <img src="/icons/icon-192.png" alt="" className="w-11 h-11 rounded-xl" />
        <div className="flex-1">
          <p className="font-semibold text-t-on text-sm">Keep calm one tap away</p>
          <p className="text-[13px] text-t-muted">Add Triggerific-Pilot to your home screen.</p>
        </div>
        <Btn size="md" className="!h-9 !px-4" label={canPrompt ? "Install" : "How"} onClick={canPrompt ? install : () => setShowSteps(!showSteps)} testId="install-banner-button" />
        <button onClick={dismiss} aria-label="Dismiss" data-testid="install-banner-dismiss" className="text-t-muted"><X size={18} /></button>
      </div>
      {showSteps ? <IOSSteps /> : null}
    </div>
  );
}
